const proivderDashboard = {
    series: [{
        name: 'Tasks',
        data: [12, 19, 15, 20, 14] // Example data for each day
    }],
    provider: {
        chart: {
            type: 'bar',
            height: 140
        },
        colors: ['#4A00E5'],
        plotOptions: {
            bar: {
                borderRadius: 5,
                // horizontal: false,
            },
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: ['M', 'T', 'W', 'T', 'F'],
        },
        // legend: {
        //     // position: 'bottom',
        //     // formatter: function(val, opts) {
        //     //     return val + " - " + opts.w.globals.series[opts.seriesIndex].reduce((a, b) => a + b, 0);
        //     // }
        // },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 300
                },
                legend: {
                    position: 'bottom'
                },
                plotOptions: {
                    bar: {
                        borderRadius: 3,
                    },
                },
            }
        }]
    }
};

const proivderLocation = {
    series: [{
        name: "sales",
        colors: ['#FFC38F'],
        data: [{
            x: 'Inpipeline',
            y: 400,

        }, {
            x: 'Follow Up',
            y: 130
        }, {
            x: 'Schedule',
            y: 248
        }, {
            x: 'Conversation',
            y: 470
        }, {
            x: 'Won',
            y: 470
        }, {
            x: 'Lost',
            y: 180
        }]
    }],
    location: {
        chart: {
            type: 'bar',
            height: 260,
        },
        plotOptions: {
            bar: {
                borderRadiusApplication: 'around',
                columnWidth: '40%',
            }
        },
        colors: ['#00918E'],
        xaxis: {
            type: 'category',
            group: {
                style: {
                    fontSize: '7px',
                    fontWeight: 700,
                },
            }
        },
    }

};

export { proivderDashboard, proivderLocation }